import { ApiABExperiment } from 'api/types/ApiABExperiment';
import {
  registerMixpanelProperties,
  unregisterMixpanelProperty,
} from 'utils/analytics/helpers/mixpanel';
import { setWindowDataLayerExperiments } from 'utils/analytics/helpers/windowDataLayerPush';
import { isNotEmpty } from 'utils/functional';

export function registerAbExperiments(
  abExperiments: ApiABExperiment[] | null | undefined
) {
  const registeredAbExperiments =
    abExperiments && isNotEmpty(abExperiments)
      ? `"${abExperiments.map((e) => `${e.id}=${e.bucket}`).join('"&"')}"`
      : null;

  if (registeredAbExperiments !== null) {
    registerMixpanelProperties({
      experiments: registeredAbExperiments,
    });
  } else {
    unregisterMixpanelProperty('experiments');
  }

  setWindowDataLayerExperiments(registeredAbExperiments || undefined);
}
